import { map } from 'lodash';
import PropTypes from 'prop-types';
import React from 'react';

import { ModelYear } from '@sm360/widget-commons-vehicle';

const AccessoryDetails = ({ option, optionItems, showAccessoryDetails }) => {
    const optionItemsLabels = map(optionItems, (item) => {
        return (
            <div className="content" key={item.code}>
                {item.description}
            </div>
        );
    });

    return (
        <div>
            <div className="accessory_wrapper--details">
                <button className="accessory_wrapper--button" onClick={showAccessoryDetails}>
                    <icon className="icon-x-config" />
                </button>
                <div className="title">{option.description}</div>
                {optionItemsLabels}
            </div>
            <div className="accessory_wrapper--check">
                <icon className="icon-Crochet" />
            </div>
        </div>
    );
};

AccessoryDetails.propTypes = {
    option: PropTypes.instanceOf(ModelYear.OptionModel).isRequired,
    optionItems: PropTypes.arrayOf(PropTypes.instanceOf(ModelYear.OptionModel)).isRequired,
    showAccessoryDetails: PropTypes.func.isRequired,
};

AccessoryDetails.displayName = 'AccessoryDetails';

export default AccessoryDetails;
